import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ApplicationCard from "../../components/admin/ApplicationCard";
import Modal from "../../components/admin/Modal"; // Import Modal

const DetailsPage = () => {
  const location = useLocation();
  const detailsUrl = location.state?.detailsUrl;
  const pathSegments = window.location.pathname.split("/");
  const pageTitle = pathSegments[pathSegments.length - 1].replace("-", " ");

  const [applications, setApplications] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);

  useEffect(() => {
    if (!detailsUrl) {
      setError("Invalid request URL.");
      setLoading(false);
      return;
    }

    const fetchApplications = async () => {
      setLoading(true);
      const token = localStorage.getItem("adminToken");
      // console.log(detailsUrl,"DDUUUUUU");
      try {
        const response = await fetch(detailsUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();

        if (data.success) {
          const sortedApps = (data.data || []).sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
          setApplications(sortedApps);
        } else {
          setError("Failed to fetch applications.");
        }
      } catch (err) {
        setError("Error fetching data.");
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, [detailsUrl]);

  // Fetch details when clicking on a card
  const handleCardClick = async (url) => {
    setLoadingModal(true);
    // console.log("Fetching details fromsssssdddd:", url);

    try {
      const token = localStorage.getItem("adminToken");
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      // console.log("Fetched Datassssss:", data);

      if (data.success) {
        setSelectedApplication(data.data); // Ensure this contains only valid fields for rendering
        // console.log(data.data,"dtttttttttttttttttttttttttttt");
        setShowModal(true); // Only show modal after successful data fetch
      } else {
        // Don't show modal if fetch fails
        setSelectedApplication({ error: "Failed to fetch details." });
        // You might want to show an error toast/message here instead
      }
    } catch (error) {
      // Don't show modal if error occurs
      setSelectedApplication({ error: "Error fetching details." });
      // You might want to show an error toast/message here instead
    } finally {
      setLoadingModal(false);
    }
  };


  // Filter Applications based on search term
  const filteredApplications = applications.filter((app) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase().trim();

    // Check parent mobile
    if (app.parent?.mobile && app.parent.mobile.includes(term)) return true;

    // Check application no or names
    if (app.application_no && app.application_no.toLowerCase().includes(term)) return true;
    if (app.first_name && app.first_name.toLowerCase().includes(term)) return true;
    if (app.last_name && app.last_name.toLowerCase().includes(term)) return true;

    // Check payment details (transactionId / providerReferenceId)
    if (app.payment_details && Array.isArray(app.payment_details)) {
      const match = app.payment_details.some(pd =>
        (pd.transactionId && pd.transactionId.toLowerCase().includes(term)) ||
        (pd.providerReferenceId && pd.providerReferenceId.toLowerCase().includes(term))
      );
      if (match) return true;
    }

    return false;
  });

  return (
    <div className="container mx-auto p-4">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        <h1 className="text-2xl font-semibold capitalize">{pageTitle} Applications</h1>

        {/* Search Input Bar */}
        <div className="w-full md:w-1/3 relative">
          <input
            type="text"
            placeholder="Search by Payment ID, Order ID, or Phone..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm transition"
          />
          {searchTerm && (
            <button
              onClick={() => setSearchTerm("")}
              className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600 focus:outline-none"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {loading && <p>Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {!loading && !error && filteredApplications.length === 0 && (
        <p className="text-gray-500 italic mt-4">No applications match your search criteria.</p>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredApplications.map((item, index) => (
          <ApplicationCard
            key={index}
            item={item}
            onShowDetails={(detailsUrl) => handleCardClick(detailsUrl)} // Change from onClick to onShowDetails
          />

        ))}
      </div>

      {/* Modal for displaying details */}
      {showModal && (
        <Modal
          loading={loadingModal}
          show={showModal}
          onClose={() => setShowModal(false)}
          formData={selectedApplication || {}} // Pass fetched data
          onFinalSubmit={() => alert("Final submit not implemented")} // Placeholder
        />
      )}
    </div>
  );
};

export default DetailsPage;
